// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MAIa","right":"styles_right__2ysm0"};